// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1366":"8d444046","3115":"a437714b","4071":"81860174","4242":"a16b74cd","6065":"5ab00a12","8110":"a437714b","9307":"568aa915","9853":"41dd65a2","9978":"dc32d884"}[chunkId] + ".chunk.css";
};